<template>
      <e-collapse title="基础设置" :expand="true">
      <t-form-item label="label">
        <t-input size="small" v-model="attribute.label" />
      </t-form-item>
      <t-form-item label="label位置">
        <t-radio-group size="small" v-model="attribute.labelAlign">
          <t-radio-button value="left">左部</t-radio-button>
          <t-radio-button value="right">右部</t-radio-button>
          <t-radio-button value="top">顶部</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="单选类型" v-if="currentCpt.cptKey == 'cpt-radio'">
        <t-radio-group size="small" v-model="attribute.radioType">
          <t-radio-button value="radio">常规型</t-radio-button>
          <t-radio-button value="button">按钮型</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="尺寸">
        <t-radio-group
          size="small"
          v-model="attribute.size"
          @change="changeSize"
        >
          <t-radio-button value="small">小</t-radio-button>
          <t-radio-button value="medium">中</t-radio-button>
          <t-radio-button value="large">大</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="宽度">
        <t-input-number
          size="small"
          :min="0"
          :max="9999"
          v-model="attribute.width"
          :decimal-places="0"
        />
      </t-form-item>
      <t-form-item label="高度">
        <t-input-number
          size="small"
          :min="0"
          :max="9999"
          v-model="attribute.height"
          :decimal-places="0"
        />
      </t-form-item>
      <t-form-item label="圆角">
        <t-input-number
          size="small"
          :min="0"
          :max="9999"
          v-model="attribute.borderRadius"
          :decimal-places="0"
        />
      </t-form-item>

    </e-collapse>
    <e-collapse title="未选中设置" :expand="true">
      <t-form-item label="背景颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.bgColor"
          size="small"
        />
      </t-form-item>
      <t-form-item label="边框颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.brColor"
          size="small"
        />
      </t-form-item>
    </e-collapse>
    <e-collapse title="选中设置" :expand="true">
      <t-form-item label="选中背景颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.activeBgColor"
          size="small"
        />
      </t-form-item>
      <t-form-item label="选中边框颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.activeBrColor"
          size="small"
        />
      </t-form-item>
      <t-form-item label="选中颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.activeBg"
          size="small"
        />
      </t-form-item>
      <t-form-item label="选中字体颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.activeColor"
          size="small"
        />
      </t-form-item>
    </e-collapse>
    <e-collapse title="字体设置" :expand="true">
      <t-form-item label="字体颜色">
        <t-color-picker
          size="small"
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.textColor"
        />
      </t-form-item>
      <t-form-item label="字体样式">
        <t-radio-group size="small" v-model="attribute.fontStyle">
          <t-radio-button value="normal">正常</t-radio-button>
          <t-radio-button value="italic">斜体</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="加粗">
        <t-radio-group size="small" v-model="attribute.fontWeight">
          <t-radio-button value="normal">正常</t-radio-button>
          <t-radio-button value="bold">加粗</t-radio-button>
          <t-radio-button value="lighter">更细</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="字体">
        <t-select size="small" v-model="attribute.fontFamily">
          <t-option
            v-for="item in textFamilyList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </t-select>
      </t-form-item>
      <t-form-item label="字体大小">
        <t-input-number
          size="small"
          :min="0"
          :max="9999"
          v-model="attribute.fontSize"
          :decimal-places="0"
        />
      </t-form-item>
    </e-collapse>
    <e-collapse title="校验设置" :expand="true">
      <t-form-item label="必填标识">
        <t-switch
          size="small"
          v-model="attribute.required"
          :label="['是', '否']"
        />
      </t-form-item>
    </e-collapse>
</template>

<script>
export default {
  name: "cpt-checkbox-option-base",
  props: {
    attribute: Object,
    currentCpt:Object,
  },
  created() {
    this.textFamilyList = require("@/assets/font/font-list");
    this.lineTypeList = require("@/assets/data/line-type");
  },
  methods:{
    changeSize(val) {
      this.$emit("changeSize", val);
    }
  }
};
</script>

<style>

</style>